import { z } from 'zod';

import { periodSearchSchema } from '@/features/workspace-usage/periodKeys';

/**
 * The AI models page's address (specs 215, 221): the period, as on Usage, and which
 * view. Absent `view` is By profile, the page as it has always opened.
 */
export const aiModelsSearchSchema = periodSearchSchema.extend({
  view: z.enum(['workflow']).optional().catch(undefined),
});

export type AiModelsView = 'profile' | 'workflow';
